import { Component } from "react";
import { Nav } from "react-bootstrap";
import ChevronListItem from "@/modules/shared/ui/ChevronListItem";
import * as Auth from "@/lib/auth";
import * as t from "@/lib/backend/manufacturing2.generated.types";
import { LINE_TAGS_ACCESS } from "@/lib/ManufacturingTags.generated";

type Props = {
    filter: string;
    plantFilter: string;
    selected: t.ILineData | null;
    lines: t.ILineData[];
    line_uuid_to_group_titles: Map<string, string[]>;
    handleLineClick: (line: t.ILineData) => void;
};

class LinesList extends Component<Props> {
    handleLineClick(line: t.ILineData) {
        // Ignore clicks for currently selected line.
        if (line === this.props.selected) {
            return;
        }

        this.props.handleLineClick(line);
    }

    includes(needle: string, line: t.ILineData): boolean {
        needle = needle.toLowerCase();
        if (needle.length === 0) return true;
        if (line.title.toLowerCase().indexOf(needle) > -1) return true;
        if (line.external_id.toLowerCase().indexOf(needle) > -1) return true;
        if (line.plant_title.toLowerCase().indexOf(needle) > -1) return true;
        if (line.plant_uuid.toLowerCase().indexOf(needle) > -1) return true;

        // search tag keys and values
        let tagsSearch = false;
        if (line.tags !== null) {
            Object.keys(line.tags).forEach(el => {
                // comparing values
                if (String(line.tags[el]).toLowerCase().indexOf(needle) > -1) {
                    tagsSearch = true;
                }
                // comparing keys
                if (el.toLowerCase().indexOf(needle) > -1) {
                    tagsSearch = true;
                }
            });
        }
        return tagsSearch;
    }

    render() {
        const linesList = this.props.lines.map(line => {
            const is_active = this.props.selected === line;

            if (this.props.plantFilter && line.plant_uuid !== this.props.plantFilter) return null;
            if (!this.includes(this.props.filter, line)) return null;
            const is_admin = Auth.isInRoles(["Admin"]);

            const show_in_digital_twin = LINE_TAGS_ACCESS.show_in_digital_twin(line.tags);

            if (!is_admin && !show_in_digital_twin) return null;

            const line_groups = this.props.line_uuid_to_group_titles.get(line.uuid);
            const line_groups_title = line_groups !== undefined ? line_groups.join(", ") : "/";

            return (
                <ChevronListItem
                    key={line.uuid}
                    text={`[${line.external_id}] - ` + line.title}
                    subtext={line.plant_title + " - " + line_groups_title}
                    onClick={() => this.handleLineClick(line)}
                    is_active={is_active}
                />
            );
        });

        return (
            <Nav variant="tabs">
                <div className="nav-tabs-parent">{linesList}</div>
            </Nav>
        );
    }
}

export default LinesList;
